import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Packages from "../pages/packages/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import IowaWaterCrisis from "../pages/iowa-water-crisis/page";
import Privacy from "../pages/privacy/page";
import Warranty from "../pages/warranty/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/packages",
    element: <Packages />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/iowa-water-crisis",
    element: <IowaWaterCrisis />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/warranty",
    element: <Warranty />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;